<template>
  <div>
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Geslo vašega uporabniškega računa <br> spremenite v zavihku
          <a class="krepko" href="/Mojprofil/Varnost">
            Varnost.
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoKomponenta'
}
</script>

<style scoped>
.modra-barva-info a.krepko {
  color: unset;
}

.info-okvir {
  width: 340px;
  height: 83px;
  display: flex;
}

@media only screen and (max-width: 420px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/UrejanjeProfila/InfoKomponenta.vue